export default "__VITE_ASSET__CQe1gGME__"